const AVAILABILITY_BASE = '/app/availability'

/**
 * Exact legacy availability pathnames → settings modal `settings_tab` slug.
 * Trailing slashes are normalized before lookup.
 *
 * Nested schedule/calendar paths and connected_calendars OAuth return flows are
 * deliberately omitted — those must keep the standalone availability SPA.
 */
const EXACT_PATH_TO_SETTINGS_TAB = Object.freeze({
  [AVAILABILITY_BASE]: null,
  [`${AVAILABILITY_BASE}/schedules`]: 'availability',
  [`${AVAILABILITY_BASE}/default_schedule`]: 'availability',
  [`${AVAILABILITY_BASE}/calendar_settings`]: 'calendar',
  [`${AVAILABILITY_BASE}/advanced_settings`]: 'advanced',
  [`${AVAILABILITY_BASE}/holidays`]: 'advanced',
  [`${AVAILABILITY_BASE}/holidays_and_out_dates`]: 'advanced',
})

function normalizePathname(pathname) {
  if (typeof pathname !== 'string' || pathname === '') {
    return null
  }
  if (pathname.length > 1 && pathname.endsWith('/')) {
    return pathname.slice(0, -1)
  }
  return pathname
}

/**
 * Map a direct load of a legacy availability tab to the settings modal calendar
 * section tab. Exact pathname matches only.
 *
 * @param {string} pathname — `location.pathname`
 * @returns {{ settingsTab: string | null } | null}
 */
export function matchLegacyAvailabilityPathToSettingsSection(pathname) {
  const normalized = normalizePathname(pathname)
  if (normalized == null || !(normalized in EXACT_PATH_TO_SETTINGS_TAB)) {
    return null
  }
  return { settingsTab: EXACT_PATH_TO_SETTINGS_TAB[normalized] }
}
